export function getManifestacaoErrorMessage(error) {
  if (!error) return 'Erro ao processar solicitação';

  if (error instanceof Error && error.message && !error.response) {
    return error.message;
  }

  const data = error?.response?.data ?? error?.data ?? error;

  if (typeof data === 'string') return data;

  return data?.details?.message || data?.message || 'Erro ao processar solicitação';
}

export function rejectManifestacaoRequest(response) {
  return Promise.reject(new Error(getManifestacaoErrorMessage(response)));
}

export function manifestacaoTemResposta(item) {
  if (!item) return false;

  if (item.status === 'RESPONDIDO' || item.status === 'DEFERIDA' || item.status === 'INDEFERIDA') {
    return true;
  }

  if (item.status === 'ADMISSIVEL' || item.status === 'INADMISSIVEL') {
    return true;
  }

  if (item.response?.date || item.response?.message) {
    return true;
  }

  if (item.resposta?.data || item.resposta?.justificativa) {
    return true;
  }

  return false;
}

export function findManifestacaoIndex(lista, item) {
  if (!Array.isArray(lista) || !item?.id) return -1;
  return lista.findIndex(element => Number(element.id) === Number(item.id));
}

const ROTULOS_RESPOSTA = {
  esclarecimento: 'RESPOSTA AO PEDIDO DE ESCLARECIMENTO ENVIADO POR',
  impugnacao: 'RESPOSTA AO PEDIDO DE IMPUGNAÇÃO ENVIADO POR',
  recurso: 'RESPOSTA À MANIFESTAÇÃO DE RECURSO ENVIADO POR',
};

export function rotuloRemetenteResposta(item, fluxo) {
  if (!manifestacaoTemResposta(item)) return '';

  return ROTULOS_RESPOSTA[fluxo] || '';
}

const ROTULOS_MANIFESTACAO_RECURSO = {
  RAZOES: 'RAZÕES APRESENTADAS POR',
  CONTRARAZOES: 'CONTRARRAZÕES APRESENTADAS POR',
  JULGAMENTO: 'JULGAMENTO DO RECURSO POR',
};

export function rotuloManifestacaoRecurso(tipo) {
  return ROTULOS_MANIFESTACAO_RECURSO[tipo] || '';
}

const CHIPS_MANIFESTACAO_RECURSO = {
  RAZOES: 'Razões',
  CONTRARAZOES: 'Contrarrazões',
  CONSIDERACAO: 'Consideração',
  JULGAMENTO: 'Julgamento',
};

export function chipManifestacaoRecurso(tipo) {
  return CHIPS_MANIFESTACAO_RECURSO[tipo] || '';
}
